import { normalize, schema } from 'normalizr'
import Vue from 'vue'

import { Api } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'
import setEntities from '@/utils/SetEntities'

export const DEPARTMENTS_LOAD = 'DEPARTMENTS_LOAD'
export const DEPARTMENT_LOAD = 'DEPARTMENT_LOAD'
export const DEPARTMENT_CREATE = 'DEPARTMENT_CREATE'
export const DEPARTMENT_UPDATE = 'DEPARTMENT_UPDATE'
export const DEPARTMENT_DESTROY = 'DEPARTMENT_DESTROY'
export const DEPARTMENT_STATE_UPDATE = 'DEPARTMENT_STATE_UPDATE'

const departmentsApi = new Api(UrlStore.DEPARTMENTS)
const departmentSchema = new schema.Entity('departments')

export default {
  namespaced: true,
  state: {
    departmentsLoaded: false,
    departmentsList: [],
    entities: {
      departments: {}
    }
  },
  getters: {
    departments(state) {
      return state.departmentsList.map((bId) => state.entities.departments[bId])
    },
    getDepartment: (state) => (departmentId) => state.entities.departments[departmentId] || null
  },
  mutations: {
    [DEPARTMENTS_LOAD](state, payload) {
      let normData = normalize(payload.items, [departmentSchema])
      state.departmentsList = normData.result
      setEntities(state, normData)
    },
    [DEPARTMENT_LOAD](state, payload) {
      let normData = normalize(payload, departmentSchema)
      setEntities(state, normData)
    },
    [DEPARTMENT_CREATE](state, department) {
      state.departmentsList.push(department.id)
      Vue.set(state.entities.departments, department.id, department)
    },
    [DEPARTMENT_UPDATE](state, department) {
      if (department.id && state.entities.departments[department.id]) {
        state.entities.departments[department.id] = Object.assign({}, state.entities.departments[department.id], department)
      }
    },
    [DEPARTMENT_DESTROY](state, department) {
      const num = state.departmentsList.findIndex((cId) => cId === department.id)
      if (num !== -1) {
        state.departmentsList.splice(num, 1)
        delete state.entities.departments[department.id]
      }
    },
    [DEPARTMENT_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    departmentsLoad({ commit }, config = {}) {
      departmentsApi.getAll(config).then((r) => {
        commit(DEPARTMENTS_LOAD, r.data)
        commit(DEPARTMENT_STATE_UPDATE, { departmentsLoaded: true })
      })
    },
    departmentSave({ commit, getters }, department) {
      if (!department.id) throw new Error('Department id is not present in `departmentSave`!')
      commit(getters.getDepartment(department.id) ? DEPARTMENT_UPDATE : DEPARTMENT_CREATE, department)
      let departmentUpdated = getters.getDepartment(department.id)

      return departmentsApi.save(departmentUpdated).then((r) => {
        if (r._isNew) {
          commit(DEPARTMENT_DESTROY, departmentUpdated) // local
          commit(DEPARTMENT_CREATE, r.data)
        } else {
          commit(DEPARTMENT_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    departmentDestroy({ commit }, department) {
      departmentsApi.destroy({ id: department.id }).then(() => {
        commit(DEPARTMENT_DESTROY, department)
      })
    }
  }
}
